import { render, staticRenderFns } from "./advancePrincipalContactSettings.vue?vue&type=template&id=076c0c6e"
import script from "./advancePrincipalContactSettings.vue?vue&type=script&lang=js"
export * from "./advancePrincipalContactSettings.vue?vue&type=script&lang=js"
import style0 from "./advancePrincipalContactSettings.vue?vue&type=style&index=0&id=076c0c6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports